import Text from '@ingka/text';
import { translate } from '@repo/phrase';

interface Props {
    capabilities: string[] | undefined;
}

export const ArticleWheelChairAccessibilityText = ({ capabilities }: Props) => {
    const isWheelChairAccessible = capabilities?.some(
        (capability) => capability === 'WHEELCHAIR' || capability === 'WHEEL_CHAIR'
    );

    return (
        <Text>
            {isWheelChairAccessible
                ? translate('services_article_delivery_view_wheelchair_accessible')
                : translate('services_article_delivery_view_no_wheelchair_accessibility_info')}
        </Text>
    );
};
